import React, { useContext, useState } from 'react';
import { SchoolContext } from '../../context/SchoolContext';
import Card from '../ui/Card';
import Input from '../ui/Input';
import Button from '../ui/Button';
import AssignmentList from './AssignmentList';

// Teacher's view for creating a new assignment
const CreateAssignmentForm = ({ onAdd }) => {
    const [name, setName] = useState('');
    const [type, setType] = useState('On-App');
    const [questions, setQuestions] = useState([{ text: '' }]);

    const handleQuestionChange = (index, value) => {
        const newQuestions = [...questions];
        newQuestions[index].text = value;
        setQuestions(newQuestions);
    };

    const addQuestion = () => setQuestions([...questions, { text: '' }]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onAdd({ name, type, questions });
        setName('');
        setQuestions([{ text: '' }]);
    };

    return (
        <form onSubmit={handleSubmit} className="mb-8">
            <h3 className="text-xl font-semibold mb-4">Create New Assignment</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <Input type="text" placeholder="Assignment Name" value={name} onChange={e => setName(e.target.value)} required />
                <select value={type} onChange={e => setType(e.target.value)} className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600">
                    <option>On-App</option>
                    <option>Off-App</option>
                </select>
            </div>
            {type === 'On-App' && (
                <div className="mb-4">
                    <h4 className="font-semibold mb-2">Questions</h4>
                    {questions.map((q, index) => (
                        <Input key={index} type="text" placeholder={`Question ${index + 1}`} value={q.text} onChange={e => handleQuestionChange(index, e.target.value)} className="mb-2" />
                    ))}
                    <button type="button" onClick={addQuestion} className="text-sm text-blue-600 hover:underline">+ Add Question</button>
                </div>
            )}
            <Button type="submit">Create Assignment</Button>
        </form>
    );
};


const AssignmentManagement = () => {
    const { assessments, setAssessments, user } = useContext(SchoolContext);

    const handleAddAssignment = (newAssignment) => {
        setAssessments(prev => [...prev, { ...newAssignment, id: Date.now() }]);
    };

    return (
        <Card title="Assignments">
            {user.role === 'Teacher' && <CreateAssignmentForm onAdd={handleAddAssignment} />}

            <div>
                <h3 className="text-xl font-semibold mb-4">{user.role === 'Student' ? 'Your Assignments' : 'Existing Assignments'}</h3>
                <AssignmentList assignments={assessments} userRole={user.role} />
            </div>
        </Card>
    );
};

export default AssignmentManagement;
